export default __webpack_public_path__ + "static/logo-18fe5f520a6003ce1fcdd930ea55507e.svg";